import {Icon} from '../../Icon/Icon';

/**
 * @param {string} lineHeight
 * @param {string} fontSize
 * @param {string} padding
 * @param {string} borderRadius
 * @param {string} display
 * @param {string} margin
 */
export const basicBtnSetup = ({lineHeight, fontSize, padding, borderRadius, display, margin}) => `
    line-height:  ${lineHeight || '1.6'};
    font-size: ${fontSize || 'var(--text-size-default)'};
    padding: ${padding || '2px 8px'};
    border-radius: ${borderRadius || '5px'};
    display: ${display || 'inline-flex'};
    margin: ${margin || '0px'};
    font-weight: 400;
    text-decoration: none;
    cursor: pointer;
    vertical-align: top;
    align-items: center;
    gap: 7px;
    justify-content: center;
    &:hover{
        transition: .6s;
    }

    &:disabled,
    &[disabled]{
        opacity: 0.7;
        cursor: not-allowed!important;
    }
    min-height: 28px;
    ${Icon.Wrapper} {
        padding-top: 2px;
        width: 14px;
        height: 14px;
        display: contents;
        svg {
            width: 14px;
            height: 14px;
        }
    }
`;

export const btnColorSetup = ({background, txt, border}) => `
    background: ${background || 'var(--disabled)'};
    border: 1px solid ${border || 'var(--disabled)'};
    color: ${txt || 'var(--default-btn-text-color)'};
`;
